import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";
import {
  setCurrentSelectedClientCode,
  setCurrentSelectedContract,
} from "../../../reducers/contracts";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownIndicator,
  formatOptionLabel,
} from "./common/components";
import { Form } from "react-bootstrap";

const ClientCodeSelect = (props) => {
  const [isKeyboard, setIsKeyboard] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        setIsKeyboard(true);
      } else if (e.key === "Tab") {
        setIsKeyboard(false);
      }
    };

    const handleMouseMove = () => {
      setIsKeyboard(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const CustomMenuList = (props) => {
    const { innerRef, innerProps, children, selectProps } = props;

    return (
      <ul
        id={selectProps.menuId || "contract-list"}
        className="contract-list"
        role="listbox"
        ref={innerRef}
        {...innerProps}
      >
        {children}
      </ul>
    );
  };

  const CustomOption = (props) => {
    const { innerRef, innerProps, isFocused, data, children } = props;
    return (
      <li
        ref={innerRef}
        role="option"
        aria-selected={value?.clientCode === data?.clientCode}
        {...innerProps}
        className={[
          "custom-option",
          isFocused && isKeyboard ? "is-focused" : "",
          value?.clientCode === data?.clientCode ? "selected-contract" : "",
        ]
          .join(" ")
          .trim()}
      >
        {children ?? data.label}
      </li>
    );
  };
  const options = useSelector((state) => {
    return _.uniqWith(
      state.contracts.list &&
        state.contracts.list.map((contract) => {
          return {
            clientCode: contract.clientCode,
            businessName: contract.accountHolder.businessName,
          };
        }),
      _.isEqual
    );
  });

  let optionChooseClientCode = { clientCode: "0" };

  let optionsWithChooseClientCode = [optionChooseClientCode].concat(options);

  let currentSelectedClientCode = useSelector(
    (state) => state.contracts.currentClientCodeSelected
  );

  const [value, setValue] = useState(currentSelectedClientCode);
  const [isOpen, setIsOpen] = useState(false);
  const { label } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const triggerUpdated = (selected) => {
    setIsOpen(false);

    let [currentClientCode] = _.filter(optionsWithChooseClientCode, (o) => {
      return o.clientCode === selected ? o : null;
    });

    dispatch(setCurrentSelectedClientCode(currentClientCode));

    if (currentClientCode.clientCode !== "0") {
      dispatch(setCurrentSelectedContract({ id: "0" }));
    }
    setValue(currentClientCode);
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const filterOption = (candidate, input) => {
    if (input) {
      return Object.values(candidate.data).some((item) => {
        if (!item) {
          return false;
        }
        return (
          item.indexOf(input) !== -1 || item.indexOf(input.toUpperCase()) !== -1
        );
      });
    }
    return true;
  };
  return (
    <Form.Group>
      {label && (
        <Form.Label
          className="paragraph-small-fs9"
          htmlFor="client-code-select"
        >
          {" "}
          {label}{" "}
        </Form.Label>
      )}
      <div
        className="ContractsSelect withEmptyOption"
        data-testid="ContractsSelect"
      >
        <Dropdown
          isOpen={value ? isOpen : false}
          onClose={toggleOpen}
          aria-expanded={isOpen}
          target={
            <div
              className={`form-control select-remote-options dropdown ${isOpen}`}
            >
              <button
                onClick={currentSelectedClientCode && toggleOpen}
                className="btn btn-contract-select btn-default  select-contracts"
                type="button"
                id={"client-code-select-dropdown"}
              >
                {currentSelectedClientCode &&
                currentSelectedClientCode.clientCode === "0" ? (
                  <>
                    <span className="button-text">
                      {t(`common.documentType.all`)}
                    </span>
                    <span className="gc-icon-functional-chevron-down contract-select-icon" />
                  </>
                ) : currentSelectedClientCode ? (
                  <>
                    <span className="button-text">
                      {currentSelectedClientCode.clientCode} -{" "}
                      {currentSelectedClientCode.businessName}
                    </span>
                    <span className="gc-icon-functional-chevron-down contract-select-icon" />
                  </>
                ) : (
                  <>
                    <span className="button-text">
                      {t(`client.code.select.no.available`)}
                    </span>
                  </>
                )}
              </button>
            </div>
          }
        >
          <Select
            autoFocus
            backspaceRemovesValue={false}
            value={value}
            formatOptionLabel={formatOptionLabel}
            options={optionsWithChooseClientCode}
            components={{
              DropdownIndicator,
              IndicatorSeparator: null,
              MenuList: CustomMenuList,
              Option: CustomOption,
            }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            menuIsOpen
            onChange={(data) => triggerUpdated(data.clientCode)}
            className={"gcap-select form-control"}
            isDisabled={optionsWithChooseClientCode.length <= 0}
            placeholder={
              optionsWithChooseClientCode.length > 0
                ? t(`client.code.select.placeholder`)
                : t(`client.code.select.no.available`)
            }
            filterOption={filterOption}
            tabSelectsValue={false}
            id="client-code-select"
          />
        </Dropdown>
      </div>
    </Form.Group>
  );
};

export default ClientCodeSelect;
